import { Task, ExpectedTaskAnswerMetadata } from "@jelly/lesson";

const items = [{ id: "9719033f-f873-4388-b4ad-141c0a3657d1", content: "Prominence Ratio", options: {} }];

const groups = [
  {
    id: "e8d23179-fbf2-4a2a-9df0-dae972e98d67",
    content: "does not operate with psychoacoustic parameters",
    options: {},
  },
  { id: "eaa9f530-780e-4380-9e0d-e7c456a49ee8", content: "ignores cavum cochae resonance of the ear", options: {} },
  { id: "39852099-6c88-49a4-a7ed-3d1f2abd1da8", content: "incompletely implemented", options: {} },
  { id: "ee0baca5-cf45-419d-ba93-f8d243831b42", content: "does not give spectral information", options: {} },
  { id: "b33beeae-c7ec-45cd-85f4-e9397f963123", content: "can only be used for pure tone analysis", options: {} },
  { id: "ad2419e3-f928-4a61-9d2a-3f3732b2beab", content: "require high frequency resolution", options: {} },
];

export const task: Task = {
  id: "1af87a1d-02b8-4aef-9d9a-8c1146461031",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
    multipleConnection: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "e8d23179-fbf2-4a2a-9df0-dae972e98d67", itemsId: ["9719033f-f873-4388-b4ad-141c0a3657d1"] },
    { groupId: "eaa9f530-780e-4380-9e0d-e7c456a49ee8", itemsId: ["9719033f-f873-4388-b4ad-141c0a3657d1"] },
    { groupId: "ee0baca5-cf45-419d-ba93-f8d243831b42", itemsId: ["9719033f-f873-4388-b4ad-141c0a3657d1"] },
    { groupId: "ad2419e3-f928-4a61-9d2a-3f3732b2beab", itemsId: ["9719033f-f873-4388-b4ad-141c0a3657d1"] },
  ],
};
